<template>
  <div class="page-wrapper msg-wrap">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <pending-items-internal :title="false" />
      <div class="page-title text-upper-case">
        <h1>Group Renewals - (Upcoming 30/60/90 days)</h1>
      </div>
      <pending-search
        @onSearch="searchData"
        @onClear="clearData"
        :pendingGroupRenewals="true"
        @onExport="handleExport"
        @dayChange="handleRenewalDaysChange"
      />
      <div class="table-card">
        <div class=" align-items-center top-pagination">
          <!-- <page-result :rows.sync="rows" /> -->
          <pagination :rows.sync="rows" :filters="filters" />
        </div>
        <simple-table :columns="columns">
          <template v-slot:tableBody>
            <pending-table
              :rows.sync="rows"
              :colSpan="columns.length"
              type="pendingGroupRenewals"
            />
          </template>
        </simple-table>
        <div class=" align-items-center">
          <!-- <page-result :rows.sync="rows" /> -->
          <pagination :rows.sync="rows" :filters="filters" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import Helper from "@/resource/Helper";
import PendingTable from "./partials/PendingGroupRenewalTable.vue";
import SimpleTable from "@/components/ui/SimpleTable.vue";
import PendingSearch from "./partials/PendingSearch.vue";
import PendingItemsInternal from "../Dashboard/partials/PendingItemsInternal.vue";
export default {
  components: {
    SimpleTable,
    PendingTable,
    PendingItemsInternal,
    PendingSearch,
  },
  name: "pendingGroupRenewals",
  data: () => ({
    rows: [],
    columns: [
      { label: "Group ID" },
      { label: "Details" },
      { label: "Members" },
      { label: "Plans" },
      { label: "Dates" },
      { label: "Remaining Days" },
      { label: "Rep" },
    ],
    filters: { search: "" },
    breadcrumbItems: [{ title: "Group Renewals", active: true }],
  }),
  methods: {
    clearData() {
      this.filters.search = "";
      this.filters.days = "";
      this.filters.groupStatus = "";
      this.getAll(this.filters);
    },
    searchData(query, groupStatus, renewalDays) {
      this.filters.search = query;
      this.filters.groupStatus = groupStatus;
      this.filters.days = renewalDays;
      this.getAll(this.filters);
    },
    getAll(filters = null) {
      let url;
      let loader = this.$loading.show();
      if (filters) {
        let filterUrl = Helper.objToUrlParams(filters);
        url = `v2/get-pending-group-renewals?${filterUrl}`;
      } else {
        url = `v2/get-pending-group-renewals`;
      }
      Api.get(url)
        .then((res) => {
          this.rows = res.data;
        })
        .catch(() => {
          this.rows = [];
        })
        .finally(() => {
          loader.hide();
        });
    },
    handleRenewalDaysChange(days) {
      this.filters.days = days;
      this.getAll(this.filters);
    },

    handleExport() {
      const loader = this.$loading.show();
      const exportParam = "export=1";
      let url;

      if (this.filters && Object.keys(this.filters).length > 0) {
        const filterUrl = Helper.objToUrlParams(this.filters);
        url = `v2/get-pending-group-renewals?${filterUrl}&${exportParam}`;
      } else {
        url = `v2/get-pending-group-renewals?${exportParam}`;
      }

      Api.get(url)
        .then((res) => {
          if (res.data?.status === "success" && res.data?.file_url) {
            window.location.href=res.data.file_url;
            // window.open(res.data.file_url, "_blank");
          } else {
            this.$notify("No data found or export failed.", "error");
          }
        })
        .catch((err) => {
          console.error("Export error:", err);
          this.$notify("Failed to export file.", "error");
        })
        .finally(() => {
          loader.hide();
        });
    },
  },
  created() {
    this.getAll(this.filters);
  },
};
</script>
<style src="@/assets/css/pending-details.css"></style>
